"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var formats = {
  bold: [{
    inline: 'b',
    remove: 'all',
    preserve_attributes: ['class', 'style']
  }, {
    inline: 'span',
    styles: {
      fontWeight: 'bold'
    }
  }, {
    inline: 'strong',
    remove: 'all',
    preserve_attributes: ['class', 'style']
  }],
  italic: [{
    inline: 'i',
    remove: 'all',
    preserve_attributes: ['class', 'style']
  }],
  underline: [{
    inline: 'u',
    remove: 'all',
    preserve_attributes: ['class', 'style']
  }],
  strikethrough: [{
    inline: 'strike',
    remove: 'all',
    preserve_attributes: ['class', 'style']
  }, {
    inline: 's',
    remove: 'all',
    preserve_attributes: ['class', 'style']
  }, {
    inline: 'span',
    styles: {
      textDecoration: 'line-through'
    },
    exact: true
  }],
  removeformat: [{
    selector: 'b,strong,em,i, italic,font,u, underline,strike,s,sub,sup,dfn,code,samp,kbd,var,cite,mark,q,del,ins,small',
    remove: 'all',
    split: true,
    block_expand: true,
    expand: false,
    deep: true
  }, {
    selector: 'span',
    attributes: ['style', 'class'],
    remove: 'empty',
    split: true,
    expand: false,
    deep: true
  }, {
    selector: 'a',
    remove: 'all'
  }, {
    selector: '*',
    attributes: ['style', 'class'],
    split: false,
    expand: false,
    deep: true
  }]
};
var _default = formats;
exports["default"] = _default;
//# sourceMappingURL=formats.js.map